// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
class _TvQuoteUtils {
    replaceNaN(price) {
        return !isNaN(price) ? price : undefined;
    }
}
export const TvQuoteUtils = new _TvQuoteUtils();
